import React from 'react';
import {
    Form,Button
} from 'antd';

import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { InputField, required} from '../../app/inputs/InputField';
let FormAgregarCategoria = props => {
    return (
      <Form onSubmit={props.handleSubmit(props.registro)} layout="horizontal"  >
        <Field name="categoria" component={InputField} ph="Categoria" validate={[required]} />
        <Form.Item>
          <div style={{display:"flex", justifyContent:"center"}}>
            <Button loading={props.loading} type="primary" htmlType="submit" className="loginFormButton">
              Guardar
            </Button>
          </div>
        </Form.Item>

      </Form>
    )
  }

const mapStateToProps = (state, props) => {
  return {
    //initialValues:props.data
  }
}

export default connect(mapStateToProps)( reduxForm({ form: 'FormAgregarCategoria' })(FormAgregarCategoria))